import Vue from 'vue';

import * as versionApi from '@authoringPlatform/../api/versions';
import constants from '../../constants';
import questions from './questions';
import skills from './skills';
import characters from './characters';
import drive from './drive';
import tags from './tags';
import version from './version';

const getDefaultState = () => ({
  isReady: false,
  isSaving: false,
  editKey: 0,
  unsavedEdits: {},
  latestLog: {
    time: '',
    authorName: '',
  },
  assetsPath: '',
  tooltips: constants.PAGE_TOOLTIPS,
});

export default {
  namespaced: true,

  state: getDefaultState(),

  modules: {
    questions,
    skills,
    characters,
    drive,
    tags,
    version,
  },

  actions: {
    getVersionData: async ({ commit }, { versionKey }) => {
      const {
        authorName,
        description,
        demoEmail,
        demoUrl,
        hasPhases,
        isPublic,
        isActive,
        isSellable,
        latestLog,
        onboardTemplateKey,
        featuredProject,
        customPageKeysArray,
        phases,
        authors: characters,
        questionGroup,
        questions,
        skills,
        tags,
        folders,
        theme,
        timer,
        role,
        versionConfigJson: versionConfig,
        versionName,
        assetsPath,
        isGatewaySeries,
      } = await versionApi.getVersionInfo(versionKey);

      commit('INITIALIZE_EDIT_MODE', {
        latestLog,
        assetsPath,
      });

      commit('version/INITIALIZE_VERSION', {
        versionKey,
        versionName,
        description,
        authorName,
        versionConfig,
        onboardTemplateKey,
        featuredProject,
        customPageKeysArray,
        isActive,
        isPublic,
        isSellable,
        hasPhases,
        phases,
        theme,
        timer,
        demoEmail,
        demoUrl,
        role,
        isGatewaySeries,
      });

      commit('characters/INITIALIZE_CHARACTERS', {
        characters,
      });

      commit('questions/INITIALIZE_QUESTIONS', {
        questions,
        questionGroup,
        characters,
      });

      commit('tags/INITIALIZE_TAGS', {
        tags,
      });

      commit('skills/INITIALIZE_SKILLS', {
        skills,
      });

      commit('drive/INITIALIZE_DRIVE', {
        folders,
      });
      commit('CHANGE_READY_STATUS', { status: true });
    },

    updateSaveStatus: ({ commit, state }) => {
      commit('UPDATE_SAVE_STATUS', { key: state.editKey, status: true });
      return state.editKey;
    },
  },

  mutations: {
    INITIALIZE_EDIT_MODE: (state, versionData) => {
      Object.entries(versionData).forEach(([versionAttr, val]) => {
        if (versionAttr in state) {
          Vue.set(state, versionAttr, val);
        }
      });
    },
    SET_IS_SAVING: (state, isSaving) => (state.isSaving = isSaving),

    UPDATE_SAVE_STATUS: (state, { key, status }) => {
      // For some reason, using Vue.set would break reactivity and prevent the unsavedEdits getter from updating
      const newUnsavedEdits = { ...state.unsavedEdits };
      newUnsavedEdits[key] = status;
      state.unsavedEdits = newUnsavedEdits;
    },

    INCREMENT_EDIT_KEY: (state) => {
      state.editKey += 1;
    },

    RESET_SAVE_STATUS: (state) => {
      state.editKey = 0;
      state.unsavedEdits = {};
    },

    UPDATE_LAST_UPDATED: (state, { authorName }) => {
      Vue.set(state.latestLog, 'time', new Date());
      Vue.set(state.latestLog, 'authorName', authorName);
    },

    CHANGE_READY_STATUS: (state, { status }) => {
      state.isReady = status;
    },
  },

  getters: {
    hasUnsavedEdits: (state) => Object.values(state.unsavedEdits).some((isUnsaved) => isUnsaved),
  },
};
